import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Filters Icon Component
 *
 * SVG icon for filters functionality, extracted from the UserDirectory JSX.
 * Uses Material-UI's SvgIcon for consistent theming and styling.
 */
const FiltersIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 26.003 26.003">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_1377"
            data-name="Rectangle 1377"
            width="26.003"
            height="26.003"
            fill="currentColor"
          />
        </clipPath>
      </defs>
      <g id="Filters_Icon" data-name="Filters Icon" transform="translate(0 0)">
        <g
          id="Group_1796"
          data-name="Group 1796"
          transform="translate(0 0)"
          clipPath="url(#clip-path)"
        >
          <path
            id="Path_2618"
            data-name="Path 2618"
            d="M21.654,0H4.346A4.349,4.349,0,0,0,0,4.346V21.657A4.351,4.351,0,0,0,4.346,26H21.657A4.352,4.352,0,0,0,26,21.657V4.346A4.351,4.351,0,0,0,21.654,0M10.3,24.6H4.346A2.945,2.945,0,0,1,1.4,21.657V4.346A2.947,2.947,0,0,1,4.346,1.4H21.654A2.947,2.947,0,0,1,24.6,4.346V21.654A2.947,2.947,0,0,1,21.654,24.6Z"
            transform="translate(0 0)"
            fill="currentColor"
          />
          <path
            id="Path_2619"
            data-name="Path 2619"
            d="M15.635,4.242H4.77a.7.7,0,1,1,0-1.4H15.635a.7.7,0,0,1,0,1.4"
            transform="translate(5.457 3.806)"
            fill="currentColor"
          />
          <path
            id="Path_2620"
            data-name="Path 2620"
            d="M4.046,4.242H2.5a.7.7,0,1,1,0-1.4H4.046a.7.7,0,1,1,0,1.4"
            transform="translate(2.412 3.806)"
            fill="currentColor"
          />
          <path
            id="Path_2621"
            data-name="Path 2621"
            d="M10.578,6.672H8.54a.7.7,0,0,1,0-1.4h2.037a.7.7,0,0,1,0,1.4"
            transform="translate(10.515 7.066)"
            fill="currentColor"
          />
          <path
            id="Path_2622"
            data-name="Path 2622"
            d="M12.9,6.672H2.5a.7.7,0,0,1,0-1.4H12.9a.7.7,0,0,1,0,1.4"
            transform="translate(2.411 7.066)"
            fill="currentColor"
          />
          <path
            id="Path_2623"
            data-name="Path 2623"
            d="M13.328,9.1H6.49a.7.7,0,0,1,0-1.4h6.837a.7.7,0,0,1,0,1.4"
            transform="translate(7.765 10.326)"
            fill="currentColor"
          />
          <path
            id="Path_2624"
            data-name="Path 2624"
            d="M8.1,9.1H2.5a.7.7,0,1,1,0-1.4H8.1a.7.7,0,0,1,0,1.4"
            transform="translate(2.412 10.326)"
            fill="currentColor"
          />
          <path
            id="Path_2625"
            data-name="Path 2625"
            d="M5.033,7.158a2.576,2.576,0,1,1,2.6-2.576v.07a2.6,2.6,0,0,1-2.6,2.505m0-3.746A1.159,1.159,0,0,0,3.862,4.583a1.183,1.183,0,0,0,2.365.037l.7-.037h-.7A1.171,1.171,0,0,0,5.033,3.412"
            transform="translate(3.296 2.692)"
            fill="currentColor"
          />
          <path
            id="Path_2626"
            data-name="Path 2626"
            d="M8.814,9.618a2.576,2.576,0,1,1,2.576-2.576A2.577,2.577,0,0,1,8.814,9.618m0-3.746A1.173,1.173,0,0,0,7.643,7.043a1.171,1.171,0,1,0,2.342,0A1.174,1.174,0,0,0,8.814,5.872"
            transform="translate(8.368 5.993)"
            fill="currentColor"
          />
          <path
            id="Path_2627"
            data-name="Path 2627"
            d="M6.763,12.048A2.576,2.576,0,1,1,9.338,9.473a2.579,2.579,0,0,1-2.576,2.576m0-3.746A1.171,1.171,0,1,0,7.933,9.473,1.174,1.174,0,0,0,6.763,8.3"
            transform="translate(5.617 9.253)"
            fill="currentColor"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default FiltersIcon;
